'use client';

export { P } from '@paypoteam/ui-components';
